import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { utilBlog } from "../../utils/utilBlog";
import { TypeActionPlayerSettingsInfo } from "../info/player-settings/actionPlayerSettingsInfo";
import { actionModalOpen, actionModalTabSelect } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { MenuSettingsCategory } from "./MenuSettingsCategory";
export var epicBlogOpen = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerSettingsInfo.ViewBlog), switchMap(function () {
        var currentBlogVersion = state$.value.playerSettingsInfo.blogVersion;
        utilBlog.setBlogVersion(currentBlogVersion);
        return from([
            actionModalOpen(IdModal.Settings),
            actionModalTabSelect(MenuSettingsCategory.Blog),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/settings/epicBlogOpen.ts
// module id = 2333
// module chunks = 3